<template>
  <b-modal
    id="schedule-sendout"
    size="lg"
    :title="trans('schedule_sendout')"
    :ok-title="trans('schedule_action')"
    :cancel-title="trans('cancel')"
    @ok="onSave"
    :ok-disabled="busy"
    @show="onShow"
  >
    <p>
      <i class="fa fa-fw fa-clock"></i>
      {{ trans('schedule_sendout_about') }}
    </p>
    <b-form-group v-for="(slot, index) in slots" :key="index">
      <b-row>
        <b-col class="col-auto">
          <label v-if="index === 0">&nbsp;</label>
          <div class="pt-1 text-right text-muted" style="min-width:30px;">{{ index + 1 }}</div>
        </b-col>
        <b-col cols="3" class="pl-0">
          <label v-if="index === 0">{{ trans('date') }}</label>
          <datetime v-model="slot.date" class="form-control-sm" :config="dateOptions" @input="onUpdate(slot)" />
        </b-col>
        <b-col cols="3" class="pl-0">
          <label v-if="index === 0">{{ trans('time') }}</label>
          <datetime v-model="slot.time" class="form-control-sm" :config="timeOptions" @input="onUpdate(slot, index)" />
        </b-col>
        <b-col cols="5" class="pl-0">
          <label v-if="index === 0">&nbsp;</label>
          <div class="pt-1">
            <span v-if="!slot.status && !slot.error">
              {{ slot.in_time }}
            </span>
            <span v-if="slot.status == 'scheduling'">
              <i class="fa fa-fw fa-circle-notch fa-spin"></i>
              {{ trans('please_wait') }}
            </span>
            <span v-if="slot.status == 'scheduled'" class="text-success">
              <i class="fa fa-fw fa-check"></i>
            </span>
            <span v-if="slot.error" class="text-danger">
              {{ slot.error }}
            </span>
            <b-button v-if="index !== 0 && !slot.status" variant="link" class="p-0 text-danger" @click="onRemove(index)" :disabled="busy">
              <i class="fa fa-fw fa-times"></i>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-form-group>
    <b-form-group class="my-4">
      <span class="pt-1">
        {{ trans('add_schedule') }}
      </span>
      <b-button variant="outline-primary" size="sm" class="ml-2 py-0" @click="onAdd(1)" :disabled="busy">
        <i class="fa fa-fw fa-plus"></i> 1 {{ trans('day') }}
      </b-button>
      <b-button variant="outline-primary" size="sm" class="ml-2 py-0" @click="onAdd(7)" :disabled="busy">
        <i class="fa fa-fw fa-plus"></i> 1 {{ trans('week') }}
      </b-button>
    </b-form-group>
    <p v-if="amiliaWillBeSynced || listCanBeModified || templateIsFrozen">
      <small class="text-muted">
        <i class="fa fa-fw fa-info-circle"></i>
        <span v-if="listCanBeModified">{{ trans('list_can_be_modified') }}</span>
        <span v-if="amiliaWillBeSynced">{{ trans('list_amilia_will_be_synced') }}</span>
        <span v-if="templateIsFrozen">{{ trans('template_is_frozen') }}</span>
      </small>
    </p>
    <b-form-group v-if="templateCanBeUnfrozen">
      <b-form-checkbox v-model="frozen" switch size="sm" :disabled="busy">
        {{ trans('freeze_template') }}
      </b-form-checkbox>
      <b-form-text>
        {{ trans(frozen ? 'template_is_frozen' : 'template_is_not_frozen') }}
      </b-form-text>
    </b-form-group>
    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  import Datetime from 'vue-bootstrap-datetimepicker';

  function buildSlot(date, time, addDays) {
    let scheduled_at = moment(date + ' ' + time, 'LLL')
    if (addDays) {
      scheduled_at.add(addDays, 'day')
      date = scheduled_at.format('LL')
    }
    return {
      date: date, // LL
      time: time, // LT
      scheduled_at: scheduled_at, // moment
      in_time: scheduled_at.fromNow(),
      isoString: scheduled_at.toISOString(),
      minutes: scheduled_at.diff(moment(), 'minutes'),
      error: null,
    }
  }

  export default {
    props: {
      organization: Object,
      user: Object,
      send_out: Object,
      to: Object,
    },
    components: {
      Datetime,
    },
    data() {
      let slot = buildSlot(
        moment().format('LL'),
        moment(moment().add(1, 'hours').startOf('hour')).format('LT'),
      )
      return {
        trans: trans,
        moment: moment,
        busy: false,
        error: null,
        slots: [slot],
        dateOptions: {
          locale: window.lang,
          format: 'LL',
        },
        timeOptions: {
          locale: window.lang,
          format: 'LT',
          stepping: 15,
        },
        frozen: true,
      }
    },
    computed: {
      maxMinutes() {
        return _.reduce(this.slots, (max, slot) => {
          if (slot.minutes > max) max = slot.minutes
          return max
        }, 0)
      },
      amiliaWillBeSynced() {
        return !!this.to &&
          (!!this.to.list && this.to.list.type.indexOf('amilia') >= 0) ||
          !!this.to.amilia_list &&
          this.maxMinutes >= 30
      },
      listCanBeModified() {
        return !!this.to && !!this.to.list
      },
      templateIsFrozen() {
        return !!this.send_out.template_id && !!this.send_out.oto_template_id
      },
      templateCanBeUnfrozen() {
        return !!this.send_out.template_id && !this.send_out.oto_template_id
      },
    },
    methods: {
      onAdd(days) {
        let last = this.slots[this.slots.length-1]
        let slot = buildSlot(last.date, last.time, days)
        this.slots.push(slot)
        this.checkErrors()
      },
      onRemove(index) {
        this.slots.splice(index, 1)
      },
      onUpdate(slot, index) {
        let s = buildSlot(slot.date, slot.time)
        slot.scheduled_at = s.scheduled_at
        slot.in_time = s.in_time
        slot.isoString = s.isoString
        slot.minutes = s.minutes
        slot.error = null
        this.checkErrors()
      },
      checkErrors() {
        const isoStrings = _.map(this.slots, 'isoString')
        for (let i = 0; i < this.slots.length; i++) {
          let slot = this.slots[i]
          let index = isoStrings.indexOf(slot.isoString)
          slot.error = index !== -1 && index != i ? trans('duplicate_row_num').replace(':row', index+1) : null
        }
      },
      onShow() {
        this.error = null
        this.busy = false
        this.frozen = true
        this.checkErrors()
      },
      onSave(e) {
        e.preventDefault()
        this.busy = true
        this.error = null

        let url = '/organization/' + this.organization.id + '/sendout'
        let options = _.clone(this.send_out)
        options.template_frozen_refresh = !this.frozen
        this.scheduleSlot(url, options, 0)
      },
      scheduleSlot(url, options, index) {
        let slot = this.slots[index]
        while (slot && !!slot.status) {
          index += 1
          slot = this.slots[index]
        }
        if (!slot) {
          this.busy = false
          return
        }
        options.scheduled_at = slot.isoString
        slot.status = 'scheduling'
        slot.error = null
        this.$forceUpdate()
        axios.post(url, options)
        .then(response => {
          slot.status = 'scheduled'
          index += 1
          if (index < this.slots.length) {
            this.$nextTick(() => {
              this.scheduleSlot(url, options, index)
            })
          } else {
            if (window.location.href.indexOf(`/organization/${this.organization.id}/sendout`) >= 0) {
              // Jump to scheduled messages screen
              this.$forceUpdate()
              setTimeout(() => {
                window.location = '/organization/' + this.organization.id + '/sendout?scheduled=true'
              }, 2000)
            } else {
              // We are in a popup - do not change page
              this.$emit('scheduled', response.data)
              this.$bvModal.hide('schedule-sendout')
            }
          }
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          slot.error = this.error
          slot.status = null
        })
      },
    },
    mounted() {
      window.scheduleComponent = this
    },
  }
</script>